module.exports = __webpack_public_path__ + "static/media/salad-days.4d5361bc.jpg";